"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyResponseTrialEndedCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const OpenCheckoutAction_1 = require("../../_shared/actions/OpenCheckoutAction");
const commands_1 = require("../../_shared/commands");
const __1 = require("../..");
const TITLE = "You've reached the end of your trial";
const SurveyResponseTrialEndedCard = (limit, webDomain) => {
    const card = __1.CardHelper.newCard();
    const container = __1.CardHelper.create(adaptivecards_1.Container, {
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    card.addItem(container);
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: TITLE,
        size: adaptivecards_1.TextSize.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `You've reached the end of your trial. You'll be returned to the free plan, which includes ${limit} responses. You can upgrade your plan to increase your limits.`,
        wrap: true,
    }));
    card.addAction((0, commands_1.DeleteCardAction)());
    card.addAction((0, OpenCheckoutAction_1.OpenCheckoutAction)(webDomain, "msteams", "Upgrade Plan", "survey-response-trial-ended"));
    card.addAction((0, OpenCheckoutAction_1.OpenCheckoutAction)(webDomain, "msteams", "Start Trial", "survey-response-trial-ended", true));
    return card;
};
exports.SurveyResponseTrialEndedCard = SurveyResponseTrialEndedCard;
//# sourceMappingURL=SurveyResponseTrialEndedCard.js.map